import { render, staticRenderFns } from "./BackNavigationBar.vue?vue&type=template&id=273cda0b&scoped=true"
import script from "./BackNavigationBar.vue?vue&type=script&lang=js"
export * from "./BackNavigationBar.vue?vue&type=script&lang=js"
import style0 from "./BackNavigationBar.vue?vue&type=style&index=0&id=273cda0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273cda0b",
  null
  
)

export default component.exports